import {
  FETCH_USERS_FAILURE,
  FETCH_USERS_LOADING,
  FETCH_USERS_SUCCESS,
  UPDATE_USER_FAILURE,
  FETCH_BY_ID_USER_SUCCESS,
  FETCH_BY_ID_USER_FAILURE,
  FETCH_BY_ID_USER_LOADING,
  UPDATE_USER_SUCCESS,
  ADD_USER_SUCCESS,
  ADD_USER_LOADING,
  UPDATE_USER_LOADING,
  ADD_USER_FAILURE,
  DELETE_USER_SUCCESS,
  DELETE_USER_LOADING,
  DELETE_USER_FAILURE,
  FETCH_BUILDING_USERS_LOADING,
  FETCH_BUILDING_USERS_SUCCESS,
  FETCH_BUILDING_USERS_FAILURE,
  FETCH_MANAGERS_FAILURE,
  FETCH_MANAGERS_SUCCESS,
  FETCH_MANAGERS_LOADING
} from '../Types/userTypes';

const initState = {
  data: [],
  managers: [],
  error: null,
  success: null,
  loading: true,
  item: {}
};

const UserReducer = function (state = initState, action) {
  switch (action.type) {
    case FETCH_USERS_LOADING:
    case ADD_USER_LOADING:
    case FETCH_MANAGERS_LOADING:
    case UPDATE_USER_LOADING:
    case DELETE_USER_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
        success: null
      };
    case FETCH_BUILDING_USERS_LOADING:
      return {
        ...state,
        loadingBuilding: true,
        error: null,
        building: [],
        success: null
      };
    case FETCH_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: null,
        data: action.payload,
        total: action.total
      };

    case FETCH_BUILDING_USERS_SUCCESS:
      return {
        ...state,
        loadingBuilding: false,
        error: null,
        success: null,
        building: action.payload
      };
    case FETCH_USERS_FAILURE:
    case FETCH_BUILDING_USERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null
      };
    case UPDATE_USER_FAILURE:
    case ADD_USER_FAILURE:
    case DELETE_USER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null
      };
    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: 'Updated successfully',
        data: state.data.map(item => (item._id === action.payload?._id ? action.payload : item))
      };

    case FETCH_BY_ID_USER_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
        success: null
      };
    case FETCH_BY_ID_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: null,
        item: action.payload
      };
    case FETCH_BY_ID_USER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null,
        item: {}
      };

    case ADD_USER_SUCCESS:
      return {
        ...state,
        data: [...state.data, action.payload],
        loading: false,
        error: null,
        success: 'User added successfully'
      };
    case DELETE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: 'User removed successfully',
        data: state.data.filter(item => item._id !== action.payload)
      };
    case FETCH_MANAGERS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: null,
        managers: action.payload
      };
    case FETCH_MANAGERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null
      };
    default:
      return { ...state };
  }
};

export default UserReducer;
